<div #myOverlay class="overlay" [ngClass]="overlayCssClass">
  <ng-content></ng-content>
</div>
